import { APIS } from '@Config/apis';
import userAuth from '@Config/userauth';
import { getLoginPath } from '@Config/userToken';
import { apiFetch } from '@Shared/Api/apiClient';

export async function logout(navigate) {
    const loginPath = getLoginPath();

    try {
        const response = await apiFetch(APIS.URLS.LOGOUT, { method: 'POST' }, {
            redirectOnUnauthorized: false
        });
        if (!response.ok) throw new Error(`Logout failed: HTTP ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error during logout:', error);
        return false;
    } finally {
        userAuth.signout(() => navigate(loginPath, { replace: true }));
    }
}
